<template>
  <div>
    <v-tooltip bottom>
      <template #activator="{ on, attrs }">
        <SecondaryButton
          @click="view"
          x-small
          v-on="on"
          v-bind="attrs"
          btnClass="mr-2 rounded"
          icon="mdi-eye"
          iconClass=""
        >
        </SecondaryButton>
      </template>
      <span>View</span>
    </v-tooltip>
    <v-tooltip bottom>
      <template #activator="{ on, attrs }">
        <PrimaryButton
          x-small
          v-on="on"
          v-if="params.data.is_pod_uploaded"
          @click="podDownload"
          v-bind="attrs"
          btnClass="mr-2 rounded"
          icon=""
          name="POD"
          iconClass=""
        >
        </PrimaryButton>
      </template>
      <span>POD download</span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  methods: {
    podDownload() {
      this.params.context.parentComponent.getConsigneeOrderAttachment(this.params.data.id);
    },
    view() {
      if (this.params && this.params.data && this.params.data.id)
        this.$router.push({
          name: "consignee-order-details",
          query: { id: this.params.data.id },
        });
    },
  },
};
</script>

<style  scoped>
.switch-font-size i {
  font-size: 29px !important;
}
.switch-font-size button {
  font-size: 29px !important;
}
</style>
